import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faPhone } from '@fortawesome/free-solid-svg-icons';
import { contattiAzienda } from '../utils/data';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setIsMenuOpen(false); }, [location]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/chi-siamo', label: 'Chi Siamo' },
    { to: '/offerte', label: 'Offerte' },
    { to: '/contattaci', label: 'Contattaci' },
  ];

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
      isScrolled 
        ? 'py-2 bg-white/95 backdrop-blur-md shadow-md' 
        : 'py-4 bg-white shadow-sm'
    }`}>
      <div className="container flex justify-between items-center">
        <Link to="/">
          <Logo size="md" />
        </Link>

        <div className={`lg:flex items-center ${
          isMenuOpen 
            ? 'fixed top-0 right-0 h-screen w-4/5 max-w-md bg-white flex flex-col pt-20 shadow-2xl transition-all duration-300 z-50' 
            : 'hidden lg:flex'
        }`}>
          {isMenuOpen && (
            <button 
              className="absolute top-5 right-5 w-10 h-10 rounded-xl bg-light-background flex items-center justify-center text-light-text"
              onClick={toggleMenu}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
          
          <nav>
            <ul className={`${isMenuOpen ? 'flex flex-col w-full' : 'flex'}`}>
              {navLinks.map((link) => (
                <li key={link.to} className={isMenuOpen ? 'w-full text-center py-1' : 'mx-1'}>
                  <Link 
                    to={link.to} 
                    className={`
                      font-medium text-sm px-4 py-2 rounded-xl transition-all duration-200
                      ${location.pathname === link.to 
                        ? 'text-primary bg-primary/5' 
                        : 'text-light-text hover:text-primary hover:bg-primary/5'
                      }
                      ${isMenuOpen ? 'block py-4 text-base' : ''}
                    `}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={`${isMenuOpen ? 'mt-8 flex flex-col items-center gap-4 px-6 w-full' : 'flex items-center ml-4'}`}>
            <a href={`tel:${contattiAzienda.telefonoPrincipale}`} className={`btn btn-cta ${isMenuOpen ? 'w-full text-center' : ''}`}>
              <FontAwesomeIcon icon={faPhone} className="mr-2" /> Consulenza Gratuita
            </a>
          </div>
        </div>

        <button 
          className="lg:hidden w-10 h-10 rounded-xl bg-primary/5 flex items-center justify-center text-primary" 
          onClick={toggleMenu}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
    </header>
  );
};

export default Header;
